import { useState } from "react";
import { createContainer } from "unstated-next";

export enum MessageType {
  success = "success",
  failed = "failed",
}

interface AlertMessage {
  id: string;
  message: string;
  type: MessageType.success | MessageType.failed;
}

export const ALERT_TIMEOUT = 4000;

export const useMessage = () => {
  const [messages, setMessages] = useState<AlertMessage[]>([]);

  const deleteMessage = (message: AlertMessage) => {
    setMessages((prevMessage) => prevMessage.filter((msg) => msg.id !== message.id));
  };

  const addMessage = (message: AlertMessage) => {
    setMessages((prevMessage) => [message].concat(prevMessage));
    let timer: NodeJS.Timeout = setTimeout(() => {
      deleteMessage(message);
    }, ALERT_TIMEOUT);

    return () => clearTimeout(timer);
  };

  const clearMessages = () => {
    setMessages([]);
  };

  return {
    messages,
    addMessage,
    deleteMessage,
    clearMessages,
  };
};

const Message = createContainer(useMessage);

export default Message;
